import {DraftError} from './DraftError.js'

export class InvalidDraftError extends DraftError {
  constructor(error) {
    super()
    const {response = {data: {}}} = error
    this._error = error
    this._message = error.message
    this._code = response.data.code || `UNKNOWN ERROR: ${error.message}`
    this._errors = response.data.errors
  }

  toJSON() {
    return {
      message: this._message,
      code: this._code,
      errors: this._errors,
      error: this._error // LINE TO BE REMOVED
    }
  }
}
